module.exports = __webpack_public_path__ + "static/media/twitter.99b75162.svg";